// Tekenen van alles wat beweegt: fietsers, katten, auto's, de rivaal, deeltjes en de scooter.
// Methoden worden op BezorgerGame.prototype gezet (zie game/mixins.js).

import { t } from '../i18n';
export class RenderActorsMixin {
  renderCyclists(ctx) {
    if (!this.map || !this.map.cyclists) return;
    ctx.save();

    for (const c of this.map.cyclists) {
      if (!this.inView(c.x, c.y, 160)) continue; // buiten beeld: overslaan
      ctx.save();
      ctx.translate(c.x, c.y);
      ctx.rotate(c.angle);

      // Schaduw
      ctx.fillStyle = 'rgba(0, 0, 0, 0.25)';
      ctx.beginPath();
      ctx.ellipse(2, 3, 14, 6, 0, 0, Math.PI * 2);
      ctx.fill();

      if (c.type === 'peloton') {
        // --- WIELRENNER ---
        // Slanke racefiets wielen (zwart rubber + zilveren velg)
        ctx.fillStyle = '#09090b';
        ctx.fillRect(-12, -1.5, 7, 3); // Achterwiel
        ctx.fillRect(6, -1.5, 7, 3);  // Voorwiel

        // Carbon framebuizen
        ctx.strokeStyle = '#e2e8f0';
        ctx.lineWidth = 1.8;
        ctx.beginPath();
        ctx.moveTo(-9, 0); ctx.lineTo(0, 0); ctx.lineTo(9, 0);
        ctx.stroke();

        // Wielrenner bovenlichaam & felle trui
        ctx.fillStyle = c.jerseyColor || '#eab308';
        ctx.beginPath();
        ctx.ellipse(-1, 0, 8, 4.5, 0, 0, Math.PI * 2);
        ctx.fill();

        // Aero Racehelm
        ctx.fillStyle = c.helmetColor || '#000000';
        ctx.beginPath();
        ctx.ellipse(4, 0, 4.5, 3.2, 0, 0, Math.PI * 2);
        ctx.fill();

        // Trappende benen (draaiend)
        const legOff = Math.sin(c.pedalPhase || 0) * 3;
        ctx.fillStyle = '#0284c7';
        ctx.fillRect(-4, -5 + legOff, 4, 3);
        ctx.fillRect(-4, 2 - legOff, 4, 3);
      } else if (c.type === 'bakfiets') {
        // --- BAKFIETSMOEDER ---
        // Houten bak voorop de fiets
        ctx.fillStyle = c.boxColor || '#b45309';
        ctx.beginPath();
        ctx.roundRect(2, -9, 16, 18, 3);
        ctx.fill();
        ctx.strokeStyle = '#78350f';
        ctx.lineWidth = 1.2;
        ctx.stroke();

        // Inhoud bakfiets: Baguettes / Tulpen
        ctx.fillStyle = '#f59e0b';
        ctx.fillRect(5, -6, 10, 4); // Brood
        ctx.fillStyle = '#ef4444';
        ctx.fillRect(5, 1, 10, 5);  // Tulpenbos

        // Oranje veiligheidswimpel / vlaggetje
        ctx.strokeStyle = '#94a3b8';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(14, -8);
        ctx.lineTo(14, -18);
        ctx.stroke();
        ctx.fillStyle = '#ea580c';
        ctx.beginPath();
        ctx.moveTo(14, -18);
        ctx.lineTo(21, -15);
        ctx.lineTo(14, -12);
        ctx.fill();

        // Fietsframe & Achterwiel
        ctx.fillStyle = c.frameColor || '#0284c7';
        ctx.fillRect(-12, -2, 14, 4);
        ctx.fillStyle = '#09090b';
        ctx.fillRect(-14, -1.5, 6, 3);

        // Bestuurster (jas + fietstas)
        ctx.fillStyle = '#065f46';
        ctx.beginPath();
        ctx.arc(-5, 0, 5, 0, Math.PI * 2);
        ctx.fill();
      }

      ctx.restore();
    }

    ctx.restore();
  }

  // Flitsmeister Radar HUD waarschuwing bij naderen van de 3 flitspalen
  renderFlitsmeisterHUD(ctx, w, h) {
    if (!this.map || !this.map.intersections) return;

    // Zoek dichtstbijzijnde actieve flitspaal
    let nearestCamDist = Infinity;
    let cameraSpotName = '';
    for (const inter of this.map.intersections) {
      if (inter.trafficLight && inter.trafficLight.hasSpeedCamera) {
        const camX = inter.x - inter.hw - 18;
        const camY = inter.y - inter.hh - 18;
        const dist = Math.hypot(this.scooter.x - camX, this.scooter.y - camY);
        if (dist < nearestCamDist) {
          nearestCamDist = dist;
          cameraSpotName = inter.name;
        }
      }
    }

    // Waarschuwing actief binnen 240px van een flitspaal
    const isOverSpeed = Math.abs(this.scooter.speed) > 3.6;
    // Rustig scherm: alleen waarschuwen als je te hard naar een flitspaal toe rijdt
    if (nearestCamDist < 220 && isOverSpeed) {
      ctx.save();
      const pulse = Math.sin(Date.now() * 0.01) * 0.2 + 0.8;

      // Geluidstrigger bij snelle nadering
      if (isOverSpeed && (!this.lastFlitsBeep || Date.now() - this.lastFlitsBeep > 2200)) {
        this.lastFlitsBeep = Date.now();
        if (this.sound && this.sound.playFlitsmeisterBeep) {
          this.sound.playFlitsmeisterBeep();
        }
      }

      // Strak Flitsmeister Radar Kaartje bovenaan het scherm
      const bannerW = 280;
      const bannerH = 46;
      const bannerX = (w - bannerW) / 2;
      const bannerY = (this.safeTop ?? 82) + 6;

      ctx.fillStyle = isOverSpeed ? 'rgba(185, 28, 28, 0.95)' : 'rgba(15, 23, 42, 0.92)';
      ctx.beginPath();
      ctx.roundRect(bannerX, bannerY, bannerW, bannerH, 10);
      ctx.fill();

      ctx.strokeStyle = isOverSpeed ? `rgba(239, 68, 68, ${pulse})` : '#38bdf8';
      ctx.lineWidth = 2;
      ctx.stroke();

      // Flitsmeister Icoon
      ctx.font = '20px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('📸', bannerX + 24, bannerY + bannerH / 2);

      // Tekst
      ctx.textAlign = 'left';
      ctx.fillStyle = '#ffffff';
      ctx.font = 'bold 12px "Plus Jakarta Sans", sans-serif';
      const distMeters = Math.round(nearestCamDist / 3.5);
      ctx.fillText(t('world.speedCamera', { m: distMeters }), bannerX + 46, bannerY + 16);

      ctx.font = '11px "Plus Jakarta Sans", sans-serif';
      ctx.fillStyle = isOverSpeed ? '#fef08a' : '#94a3b8';
      const speedAdvice = isOverSpeed ? t('world.speedWarning') : t('world.location', { place: cameraSpotName });
      ctx.fillText(speedAdvice, bannerX + 46, bannerY + 32);

      ctx.restore();
    }
  }

  renderDynamicObstacles(ctx) {
    // 1. Actieve Stadsconcurrent Knus Expres
    this.renderKnusExpres(ctx);

    // 2. Road works gravel excavation pits, dranghekken (Barriers) & LED Omleiding arrows
    const rwList = Array.isArray(this.map.roadWorks) ? this.map.roadWorks : (this.map.roadWorks ? [this.map.roadWorks] : []);
    const nowSec = performance.now() / 1000;

    for (const rw of rwList) {
      // A. Excavation sand trench
      if (rw.sand) {
        ctx.save();
        ctx.fillStyle = '#ca8a04'; // Warm sand/gravel trench
        ctx.fillRect(rw.sand.x, rw.sand.y, rw.sand.w, rw.sand.h);
        ctx.fillStyle = '#a16207';
        // Gravel grain specks
        for (let gx = rw.sand.x + 4; gx < rw.sand.x + rw.sand.w; gx += 12) {
          ctx.fillRect(gx, rw.sand.y + 6, 2.5, 2.5);
          ctx.fillRect(gx + 5, rw.sand.y + rw.sand.h - 8, 2.0, 2.0);
        }
        ctx.strokeStyle = '#78350f';
        ctx.lineWidth = 1.5;
        ctx.strokeRect(rw.sand.x, rw.sand.y, rw.sand.w, rw.sand.h);
        ctx.restore();
      }

      // B. Barrier shadow & red/white planks
      ctx.save();
      ctx.fillStyle = 'rgba(0, 0, 0, 0.25)';
      ctx.fillRect(rw.x + 3, rw.y + 3, rw.w, rw.h);

      // Red and white hazard planks
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(rw.x, rw.y, rw.w, rw.h);
      ctx.fillStyle = '#ef4444';
      if (rw.w >= rw.h) {
        for (let x = rw.x; x < rw.x + rw.w; x += 18) {
          ctx.fillRect(x, rw.y, 9, rw.h);
        }
      } else {
        for (let y = rw.y; y < rw.y + rw.h; y += 18) {
          ctx.fillRect(rw.x, y, rw.w, 9);
        }
      }
      ctx.strokeStyle = '#292524';
      ctx.lineWidth = 2;
      ctx.strokeRect(rw.x, rw.y, rw.w, rw.h);

      // C. Flashing LED amber arrow / Omleiding sign
      const flashOn = Math.floor(nowSec * 3) % 2 === 0;
      const signX = rw.x + (rw.w >= rw.h ? rw.w / 2 : rw.w / 2);
      const signY = rw.y - 14;

      ctx.fillStyle = '#1c1917';
      ctx.fillRect(signX - 42, signY - 10, 84, 18);
      ctx.strokeStyle = '#f59e0b';
      ctx.lineWidth = 1.5;
      ctx.strokeRect(signX - 42, signY - 10, 84, 18);

      ctx.fillStyle = flashOn ? '#fbbf24' : '#78350f';
      ctx.font = 'bold 9px monospace';
      ctx.textAlign = 'center';
      ctx.fillText(rw.dir === 'right' ? t('world.detourRight') : t('world.detourLeft'), signX, signY + 3);

      ctx.restore();
    }

    // 3. Bouncing/tiltable traffic cones (Pionnen)
    if (this.map.cones) {
      for (const c of this.map.cones) {
        ctx.save();
        ctx.translate(c.x, c.y);
        if (c.knocked) {
          const tilt = Math.atan2(c.vy, c.vx) || 0.8;
          ctx.rotate(tilt);
        }
        // Base square
        ctx.fillStyle = '#ea580c';
        ctx.fillRect(-8, -8, 16, 16);
        // Cone circles (orange & reflective white ring)
        ctx.fillStyle = '#f97316';
        ctx.beginPath();
        ctx.arc(0, 0, 7, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#ffffff';
        ctx.beginPath();
        ctx.arc(0, 0, 4, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#f97316';
        ctx.beginPath();
        ctx.arc(0, 0, 2, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
    }

    // 4. Dynamische Tijdelijke Files & Opstoppingen (Traffic Jams)
    // De lelijke rode rechthoek is VOLLEDIG verwijderd; auto's worden als echte fysieke 3D voertuigen getoond!
    if (this.map.trafficJams) {
      for (const jam of this.map.trafficJams) {
        if (!jam.active) continue;

        // A. Render uitlaatwolkjes van stilstaande auto's in de file
        if (jam.cars) {
          for (const car of jam.cars) {
            if (car.smokeParticles && car.smokeParticles.length > 0) {
              for (const p of car.smokeParticles) {
                ctx.save();
                ctx.fillStyle = `rgba(160, 175, 195, ${Math.max(0, p.alpha * 0.45)})`;
                ctx.beginPath();
                ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
                ctx.fill();
                ctx.restore();
              }
            }
          }
        }

        // B. Realistisch Nederlands Rijkswaterstaat LED Matrixportaal langs de weg
        ctx.save();
        const isHoriz = jam.axis === 'horizontal';
        // Plaatsing van het matrixbord netjes in de berm aan het begin van de file
        const signX = isHoriz ? (jam.x + 30) : (jam.x - 22);
        const signY = isHoriz ? (jam.y - 18) : (jam.y + 30);

        // Stalen mast/portaalpaal in het wegdek
        ctx.fillStyle = '#334155';
        ctx.fillRect(signX - 3, signY, 6, 20);
        ctx.fillStyle = '#0f172a';
        ctx.fillRect(signX - 5, signY + 18, 10, 4);

        // Donkere LED Matrix Behuizing
        ctx.fillStyle = '#09090b';
        ctx.strokeStyle = '#475569';
        ctx.lineWidth = 1.5;
        ctx.beginPath();
        ctx.roundRect(signX - 44, signY - 26, 88, 26, 4);
        ctx.fill();
        ctx.stroke();

        // Knipperende amber LED signaallampen op de 4 hoeken van het matrixbord
        const flash = Math.floor(Date.now() / 320) % 2 === 0;
        const amberColor = flash ? '#f59e0b' : '#78350f';
        ctx.fillStyle = amberColor;
        if (flash) {
          ctx.shadowColor = '#f59e0b';
          ctx.shadowBlur = 8;
        }
        ctx.beginPath();
        ctx.arc(signX - 38, signY - 20, 2.5, 0, Math.PI * 2);
        ctx.arc(signX + 38, signY - 20, 2.5, 0, Math.PI * 2);
        ctx.arc(signX - 38, signY - 6, 2.5, 0, Math.PI * 2);
        ctx.arc(signX + 38, signY - 6, 2.5, 0, Math.PI * 2);
        ctx.fill();
        ctx.shadowBlur = 0;

        // Matrixbord tekst in authentiek amber LED display
        ctx.fillStyle = '#fef08a';
        ctx.font = 'bold 8.5px "Plus Jakarta Sans", monospace';
        ctx.textAlign = 'center';
        ctx.fillText(t('world.jam'), signX, signY - 14);

        // Subtekst / status
        ctx.fillStyle = jam.slalomCooldown > 0 ? '#4ade80' : '#fb923c';
        ctx.font = 'bold 7.5px "Plus Jakarta Sans", sans-serif';
        ctx.fillText(jam.slalomCooldown > 0 ? t('world.slalomActive') : t('world.slalom'), signX, signY - 4);

        ctx.restore();
      }
    }
  }

  // Dedicated rendering for competitor Knus Expres van (chassis, headlights, opening door, courier & speech)
  renderKnusExpres(ctx) {
    const v = this.map.van;
    if (!v) return;

    // 1. Render exhaust smoke particles (in world coordinates)
    if (v.smokeParticles && v.smokeParticles.length > 0) {
      for (const p of v.smokeParticles) {
        ctx.save();
        ctx.fillStyle = `rgba(180, 190, 205, ${Math.max(0, p.alpha * 0.55)})`;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
    }

    ctx.save();
    ctx.translate(v.x, v.y);
    ctx.rotate(v.angle);

    const halfL = (v.w || 96) / 2;
    const halfW = (v.h || 46) / 2;

    // Headlight Beams (Active in Night or Rain / Mist)
    if (this.isNight || this.weather === 'rain' || this.weather === 'mist') {
      ctx.save();
      const beamGrad = ctx.createLinearGradient(halfL, 0, halfL + 180, 0);
      beamGrad.addColorStop(0, 'rgba(254, 240, 138, 0.42)');
      beamGrad.addColorStop(0.3, 'rgba(254, 240, 138, 0.18)');
      beamGrad.addColorStop(1, 'rgba(254, 240, 138, 0)');
      ctx.fillStyle = beamGrad;
      // Upper beam
      ctx.beginPath();
      ctx.moveTo(halfL - 2, -halfW + 7);
      ctx.lineTo(halfL + 175, -halfW - 35);
      ctx.lineTo(halfL + 175, -halfW + 40);
      ctx.closePath();
      ctx.fill();
      // Lower beam
      ctx.beginPath();
      ctx.moveTo(halfL - 2, halfW - 7);
      ctx.lineTo(halfL + 175, halfW - 40);
      ctx.lineTo(halfL + 175, halfW + 35);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
    }

    // 2. Van Drop Shadow
    ctx.fillStyle = 'rgba(0, 0, 0, 0.28)';
    ctx.beginPath();
    ctx.roundRect(-halfL + 3, -halfW + 4, v.w, v.h, 10);
    ctx.fill();

    // 3. Rubber Wheels & Hubcaps
    const wheelPositions = [
      { x: halfL - 22, y: -halfW - 2 },
      { x: halfL - 22, y: halfW + 2 },
      { x: -halfL + 22, y: -halfW - 2 },
      { x: -halfL + 22, y: halfW + 2 }
    ];
    for (const wp of wheelPositions) {
      ctx.fillStyle = '#1e293b';
      ctx.fillRect(wp.x - 9, wp.y - 4, 18, 8);
      ctx.fillStyle = '#94a3b8';
      ctx.fillRect(wp.x - 4, wp.y - 2, 8, 4);
    }

    // 4. Van Body Chassis (Cream white with crisp outline)
    ctx.fillStyle = '#fdfbf7';
    ctx.strokeStyle = '#475569';
    ctx.lineWidth = 1.8;
    ctx.beginPath();
    ctx.roundRect(-halfL, -halfW, v.w, v.h, 10);
    ctx.fill();
    ctx.stroke();

    // 5. Competitor Express Livery (Burgundy & Flame Orange Decals)
    ctx.fillStyle = '#e11d48'; // Rose/burgundy racing decal
    ctx.fillRect(-halfL + 10, -halfW + 5, v.w - 28, 7);
    ctx.fillStyle = '#f97316'; // Bright orange accent
    ctx.fillRect(-halfL + 10, -halfW + 12, v.w - 28, 3);

    ctx.fillStyle = '#e11d48';
    ctx.fillRect(-halfL + 10, halfW - 12, v.w - 28, 7);
    ctx.fillStyle = '#f97316';
    ctx.fillRect(-halfL + 10, halfW - 15, v.w - 28, 3);

    // Roof text banner / brand
    ctx.save();
    ctx.fillStyle = '#0f172a';
    ctx.font = 'black 9px "Plus Jakarta Sans", sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('⚡ KNUS EXPRES ⚡', -4, -1);
    ctx.fillStyle = '#b91c1c';
    ctx.font = 'bold 7px sans-serif';
    ctx.fillText(t('world.rival'), -4, 9);
    ctx.restore();

    // 6. Front Windshield & Windows
    ctx.fillStyle = '#38bdf8';
    ctx.strokeStyle = '#0284c7';
    ctx.lineWidth = 1.2;
    ctx.beginPath();
    ctx.roundRect(halfL - 25, -halfW + 6, 15, v.h - 12, 4);
    ctx.fill();
    ctx.stroke();

    // Driver silhouette (Sjors with cap)
    ctx.fillStyle = 'rgba(15, 23, 42, 0.75)';
    ctx.beginPath();
    ctx.arc(halfL - 17, -halfW + 16, 4.5, 0, Math.PI * 2);
    ctx.fill();

    // Side Windows
    ctx.fillStyle = '#0284c7';
    ctx.fillRect(halfL - 42, -halfW + 4, 13, 5); // Driver side window
    ctx.fillRect(halfL - 42, halfW - 9, 13, 5); // Passenger side window

    // Front Bumper & Headlights
    ctx.fillStyle = '#334155';
    ctx.fillRect(halfL - 3, -halfW + 8, 4, v.h - 16);
    // Headlights
    ctx.fillStyle = '#fef08a';
    ctx.fillRect(halfL - 2, -halfW + 6, 3, 5);
    ctx.fillRect(halfL - 2, halfW - 11, 3, 5);

    // Rear Taillights
    ctx.fillStyle = '#dc2626';
    ctx.fillRect(-halfL - 1, -halfW + 6, 3, 6);
    ctx.fillRect(-halfL - 1, halfW - 12, 3, 6);

    // 8. Driver Door (Swings open outward when delivering)
    if (v.doorOpen) {
      let side = -1;
      if (v.targetDoorX && v.targetDoorY) {
        const toDx = v.targetDoorX - v.x;
        const toDy = v.targetDoorY - v.y;
        const cross = Math.cos(v.angle) * toDy - Math.sin(v.angle) * toDx;
        side = (cross >= 0) ? 1 : -1;
      }
      ctx.save();
      ctx.translate(halfL - 30, side * halfW);
      ctx.rotate(side * 0.95);
      ctx.fillStyle = '#f8fafc';
      ctx.strokeStyle = '#ef4444';
      ctx.lineWidth = 2;
      ctx.fillRect(0, -3, 24, 6);
      ctx.strokeRect(0, -3, 24, 6);
      // Safety reflector on door edge
      ctx.fillStyle = '#ef4444';
      ctx.fillRect(18, -2.5, 5, 5);
      ctx.restore();
    }

    ctx.restore();

    // 8b. Delivered package at customer's doorstep with festive sparkle
    if (v.state === 'delivering' && v.packageDelivered && v.targetDoorX && v.targetDoorY) {
      ctx.save();
      ctx.fillStyle = 'rgba(0, 0, 0, 0.25)';
      ctx.fillRect(v.targetDoorX - 6, v.targetDoorY - 2, 12, 4);
      // Delivery package box
      ctx.fillStyle = '#d97706';
      ctx.strokeStyle = '#78350f';
      ctx.lineWidth = 1.2;
      ctx.fillRect(v.targetDoorX - 5, v.targetDoorY - 8, 10, 8);
      ctx.strokeRect(v.targetDoorX - 5, v.targetDoorY - 8, 10, 8);
      // Knus Expres red tape strip
      ctx.fillStyle = '#ef4444';
      ctx.fillRect(v.targetDoorX - 1, v.targetDoorY - 8, 2, 8);
      // Delivery star sparkle
      ctx.fillStyle = '#facc15';
      ctx.font = 'bold 9px sans-serif';
      ctx.fillText('✨', v.targetDoorX + 7, v.targetDoorY - 4);
      ctx.restore();
    }

    // 8c. Render animated Courier Sjors walking across the sidewalk in world coordinates
    if (v.courierVisible && v.state === 'delivering') {
      this.renderCourierSjors(ctx, v);
    }

    // 9. Speech Bubble above Knus Expres (in world coordinates, upright)
    if (v.speechText && v.speechTimer > 0 && (v.race || this.near(v.x, v.y, 380))) {
      this.renderVanSpeechBubble(ctx, v);
    }
  }

  renderCourierSjors(ctx, v) {
    if (!v.courierVisible) return;
    ctx.save();
    // 1. Soft ground shadow
    ctx.fillStyle = 'rgba(0, 0, 0, 0.28)';
    ctx.beginPath();
    ctx.ellipse(v.courierX, v.courierY + 2, 8, 4.5, 0, 0, Math.PI * 2);
    ctx.fill();

    ctx.translate(v.courierX, v.courierY);
    ctx.rotate(v.courierAngle || 0);

    // 2. Animated walking feet / shoes
    const walkOffset = Math.sin(v.courierWalkCycle || 0) * 4.5;
    ctx.fillStyle = '#1e293b'; // Slate shoes
    // Left shoe
    ctx.fillRect(-3 + walkOffset, -7, 6, 3.5);
    // Right shoe
    ctx.fillRect(-3 - walkOffset, 3.5, 6, 3.5);

    // 3. Courier uniform torso (Burgundy Knus Expres jacket)
    ctx.fillStyle = '#991b1b'; // Deep burgundy
    ctx.beginPath();
    ctx.roundRect(-6, -6, 12, 12, 3);
    ctx.fill();

    // Red shoulder trim
    ctx.fillStyle = '#ef4444';
    ctx.fillRect(-5, -6, 10, 2);
    ctx.fillRect(-5, 4, 10, 2);

    // 4. Courier Head & Red Cap with Visor
    // Head base
    ctx.fillStyle = '#fed7aa'; // Warm skin tone
    ctx.beginPath();
    ctx.arc(0, 0, 4.5, 0, Math.PI * 2);
    ctx.fill();

    // Burgundy Courier Cap
    ctx.fillStyle = '#b91c1c';
    ctx.beginPath();
    ctx.arc(-0.5, 0, 4.5, -Math.PI / 2, Math.PI / 2, true);
    ctx.fill();

    // Cap Visor pointing in walking direction
    ctx.fillStyle = '#7f1d1d';
    ctx.beginPath();
    ctx.moveTo(2, -3.5);
    ctx.lineTo(6.5, -2);
    ctx.lineTo(6.5, 2);
    ctx.lineTo(2, 3.5);
    ctx.closePath();
    ctx.fill();

    // 5. Package in hands or swinging arms
    if (v.courierHasBox) {
      // Both arms holding cardboard box out in front
      ctx.fillStyle = '#991b1b';
      ctx.fillRect(0, -6, 7, 3);
      ctx.fillRect(0, 3, 7, 3);

      // Cardboard box
      ctx.fillStyle = '#d97706';
      ctx.strokeStyle = '#78350f';
      ctx.lineWidth = 1;
      ctx.fillRect(5, -6.5, 9, 13);
      ctx.strokeRect(5, -6.5, 9, 13);

      // Knus Expres red tape strip
      ctx.fillStyle = '#ef4444';
      ctx.fillRect(7, -6.5, 2.5, 13);
    } else {
      // Arms swinging while walking empty-handed
      ctx.fillStyle = '#991b1b';
      ctx.fillRect(-4 - walkOffset * 0.7, -7, 7, 3);
      ctx.fillRect(-4 + walkOffset * 0.7, 4, 7, 3);
    }

    ctx.restore();
  }

  renderVanSpeechBubble(ctx, v) {
    ctx.save();
    ctx.font = 'bold 11px "Plus Jakarta Sans", sans-serif';
    const text = v.speechText;
    const textW = ctx.measureText(text).width;
    const padX = 10;
    const boxW = Math.max(140, textW + padX * 2);
    const boxH = 24;
    const bubbleX = v.x - boxW / 2;
    const bubbleY = v.y - 48;

    // Shadow
    ctx.fillStyle = 'rgba(0, 0, 0, 0.3)';
    ctx.beginPath();
    ctx.roundRect(bubbleX + 2, bubbleY + 2, boxW, boxH, 8);
    ctx.fill();

    // Bubble body
    ctx.fillStyle = '#fff1f2'; // Warm rose/cream tint
    ctx.strokeStyle = '#e11d48'; // Bold rose border
    ctx.lineWidth = 1.8;
    ctx.beginPath();
    ctx.roundRect(bubbleX, bubbleY, boxW, boxH, 8);
    ctx.fill();
    ctx.stroke();

    // Small triangular arrow pointing down to van
    ctx.beginPath();
    ctx.moveTo(v.x - 5, bubbleY + boxH);
    ctx.lineTo(v.x, bubbleY + boxH + 6);
    ctx.lineTo(v.x + 5, bubbleY + boxH);
    ctx.fillStyle = '#fff1f2';
    ctx.fill();
    ctx.strokeStyle = '#e11d48';
    ctx.stroke();

    // Text
    ctx.fillStyle = '#881337';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, v.x, bubbleY + boxH / 2);
    ctx.restore();
  }

  renderCats(ctx) {
    if (!this.map.cats) return;

    for (const cat of this.map.cats) {
      if (!this.inView(cat.x, cat.y, 120)) continue; // buiten beeld: overslaan
      ctx.save();
      ctx.translate(cat.x, cat.y);

      // State: Dood (overleden na aanrijding)
      if (cat.dead) {
        // 1. Schaduw & cartoon plet-effect
        ctx.save();
        ctx.rotate(cat.angle);

        // Pletcirkel / deuk op straat
        ctx.fillStyle = 'rgba(0, 0, 0, 0.22)';
        ctx.beginPath();
        ctx.ellipse(0, 0, 16, 11, 0, 0, Math.PI * 2);
        ctx.fill();

        // Geplet lijfje
        ctx.fillStyle = cat.breed === 'black' ? '#27272a' : (cat.breed === 'ginger' ? '#ea580c' : '#78716c');
        ctx.beginPath();
        ctx.ellipse(0, 0, 14, 9, 0, 0, Math.PI * 2);
        ctx.fill();
        ctx.strokeStyle = 'rgba(0,0,0,0.3)';
        ctx.lineWidth = 1;
        ctx.stroke();

        // Pleister / verbandkruisje op de rug
        ctx.fillStyle = '#fde047';
        ctx.fillRect(-4, -2, 8, 4);
        ctx.fillRect(-2, -4, 4, 8);

        // Kruisjes voor de ogen (X X)
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 1.6;
        // Linkeroog X
        ctx.beginPath();
        ctx.moveTo(7, -3); ctx.lineTo(11, -1);
        ctx.moveTo(11, -3); ctx.lineTo(7, -1);
        ctx.stroke();
        // Rechteroog X
        ctx.beginPath();
        ctx.moveTo(7, 1); ctx.lineTo(11, 3);
        ctx.moveTo(11, 1); ctx.lineTo(7, 3);
        ctx.stroke();

        // Sterretjes van duizeligheid die ronddraaien
        const starTime = Date.now() * 0.005;
        for (let s = 0; s < 3; s++) {
          const sAngle = starTime + (s * (Math.PI * 2 / 3));
          const sx = Math.cos(sAngle) * 15;
          const sy = Math.sin(sAngle) * 9;
          ctx.fillStyle = '#facc15';
          ctx.beginPath();
          ctx.arc(sx, sy, 2.2, 0, Math.PI * 2);
          ctx.fill();
        }

        ctx.restore();

        // 2. Hemels kattengeestje dat opstijgt (spirit / ghost)
        if (cat.ghostAlpha > 0.02) {
          ctx.save();
          ctx.globalAlpha = Math.min(0.9, cat.ghostAlpha);
          ctx.translate(0, cat.ghostY || -10);

          // Zwevend wit wolkje / zieltje
          ctx.fillStyle = 'rgba(255, 255, 255, 0.85)';
          ctx.beginPath();
          ctx.arc(0, 0, 8, 0, Math.PI * 2);
          ctx.arc(-5, 4, 6, 0, Math.PI * 2);
          ctx.arc(5, 4, 6, 0, Math.PI * 2);
          ctx.fill();

          // Engeltjes aureooltje (halo)
          ctx.strokeStyle = '#fef08a';
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.ellipse(0, -11, 6, 2.5, 0, 0, Math.PI * 2);
          ctx.stroke();

          // Schattige slapende oogjes op het geestje
          ctx.strokeStyle = '#475569';
          ctx.lineWidth = 1.2;
          ctx.beginPath();
          ctx.arc(-3, 0, 2, Math.PI, 0);
          ctx.arc(3, 0, 2, Math.PI, 0);
          ctx.stroke();

          ctx.restore();
        }

        // Naamlabel: Grafmonumentje / In vrede
        ctx.fillStyle = '#ffffff';
        ctx.strokeStyle = 'rgba(0,0,0,0.85)';
        ctx.lineWidth = 2.5;
        ctx.font = 'bold 9.5px "Plus Jakarta Sans", sans-serif';
        ctx.textAlign = 'center';
        const ripLabel = `🪦 ${cat.name} †`;
        ctx.strokeText(ripLabel, 0, -22);
        ctx.fillText(ripLabel, 0, -22);

        ctx.restore();
        continue;
      }

      // 3D Top-Down Actieve Kat
      ctx.rotate(cat.angle);

      // Kleurenpallet per ras
      let coatMain = '#f97316';
      let coatShade = '#c2410c';
      let coatHighlight = '#fed7aa';
      let eyeColor = '#10b981';
      let collarColor = '#ef4444';

      if (cat.breed === 'tabby') {
        coatMain = '#a8a29e'; coatShade = '#57534e'; coatHighlight = '#f5f5f4'; eyeColor = '#eab308'; collarColor = '#0284c7';
      } else if (cat.breed === 'black') {
        coatMain = '#18181b'; coatShade = '#09090b'; coatHighlight = '#3f3f46'; eyeColor = '#22c55e'; collarColor = '#e11d48';
      } else if (cat.breed === 'calico') {
        coatMain = '#fafaf9'; coatShade = '#f97316'; coatHighlight = '#ffffff'; eyeColor = '#06b6d4'; collarColor = '#8b5cf6';
      } else if (cat.breed === 'siamese') {
        coatMain = '#f5f5f4'; coatShade = '#451a03'; coatHighlight = '#ffffff'; eyeColor = '#38bdf8'; collarColor = '#ec4899';
      } else if (cat.breed === 'golden') {
        coatMain = '#f59e0b'; coatShade = '#b45309'; coatHighlight = '#fef3c7'; eyeColor = '#10b981'; collarColor = '#14b8a6';
      } else if (cat.breed === 'tuxedo') {
        coatMain = '#18181b'; coatShade = '#09090b'; coatHighlight = '#ffffff'; eyeColor = '#eab308'; collarColor = '#6366f1';
      } else if (cat.breed === 'spotted') {
        coatMain = '#fde047'; coatShade = '#b45309'; coatHighlight = '#fef9c3'; eyeColor = '#14b8a6'; collarColor = '#f97316';
      }

      const walk = cat.walkCycle || 0;
      const isMoving = (cat.state === 'walking' || cat.state === 'fleeing');
      const pawOffset = isMoving ? Math.sin(walk) * 3.5 : 0;
      const pawOffsetAlt = isMoving ? Math.sin(walk + Math.PI) * 3.5 : 0;

      // 1. Zachte 3D Grondschaduw met diepte
      ctx.fillStyle = 'rgba(0, 0, 0, 0.24)';
      ctx.beginPath();
      ctx.ellipse(1, 3, 13, 8.5, 0, 0, Math.PI * 2);
      ctx.fill();

      // 2. Vier bewegende pootjes (Animated 3D Paws)
      // Linksvoor
      ctx.fillStyle = (cat.breed === 'tuxedo' || cat.breed === 'calico') ? '#ffffff' : (cat.breed === 'siamese' ? coatShade : coatMain);
      ctx.beginPath();
      ctx.ellipse(7 + pawOffset, -7, 3.2, 2.4, 0.1, 0, Math.PI * 2);
      ctx.fill();
      // Rechtsvoor
      ctx.beginPath();
      ctx.ellipse(7 + pawOffsetAlt, 7, 3.2, 2.4, -0.1, 0, Math.PI * 2);
      ctx.fill();
      // Linksachter
      ctx.beginPath();
      ctx.ellipse(-7 + pawOffsetAlt, -6.5, 3.4, 2.6, -0.1, 0, Math.PI * 2);
      ctx.fill();
      // Rechtsachter
      ctx.beginPath();
      ctx.ellipse(-7 + pawOffset, 6.5, 3.4, 2.6, 0.1, 0, Math.PI * 2);
      ctx.fill();

      // 3. 3D Zwiepende Staart (Dynamic articulated swishing tail)
      const tailSwish = Math.sin(cat.tailPhase || 0) * (cat.state === 'fleeing' ? 9.5 : 5.5);
      ctx.strokeStyle = (cat.breed === 'siamese') ? coatShade : coatMain;
      ctx.lineWidth = 3.6;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(-10, 0);
      ctx.quadraticCurveTo(-16, tailSwish * 0.6, -23, tailSwish);
      ctx.stroke();

      // Fluffig staartpuntje
      ctx.fillStyle = (cat.breed === 'siamese' || cat.breed === 'ginger') ? coatShade : coatHighlight;
      ctx.beginPath();
      ctx.arc(-23, tailSwish, 2.2, 0, Math.PI * 2);
      ctx.fill();

      // 4. 3D Kattenromp (Ellipsoid body with spherical gradient lighting)
      const bodyGrad = ctx.createRadialGradient(-1, -2, 2, 0, 0, 11);
      bodyGrad.addColorStop(0, coatHighlight);
      bodyGrad.addColorStop(0.45, coatMain);
      bodyGrad.addColorStop(1, coatShade);

      ctx.fillStyle = bodyGrad;
      ctx.beginPath();
      ctx.ellipse(0, 0, 11, 7.8, 0, 0, Math.PI * 2);
      ctx.fill();

      // Raskenmerken & vachtpatronen op de 3D rug
      if (cat.breed === 'ginger' || cat.breed === 'tabby') {
        // Tijgerstrepen
        ctx.strokeStyle = coatShade;
        ctx.lineWidth = 1.4;
        ctx.beginPath();
        ctx.moveTo(-4, -6); ctx.lineTo(-2, -1);
        ctx.moveTo(-4, 6); ctx.lineTo(-2, 1);
        ctx.moveTo(2, -6.5); ctx.lineTo(3.5, -1.5);
        ctx.moveTo(2, 6.5); ctx.lineTo(3.5, 1.5);
        ctx.stroke();
      } else if (cat.breed === 'calico') {
        // Zwarte en oranje vlekken
        ctx.fillStyle = '#1e293b';
        ctx.beginPath();
        ctx.arc(-3, -3, 3.5, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#ea580c';
        ctx.beginPath();
        ctx.arc(3, 2, 3.2, 0, Math.PI * 2);
        ctx.fill();
      } else if (cat.breed === 'tuxedo') {
        // Wit borststuk (bib)
        ctx.fillStyle = '#ffffff';
        ctx.beginPath();
        ctx.ellipse(2, 0, 5, 4, 0, 0, Math.PI * 2);
        ctx.fill();
      } else if (cat.breed === 'spotted') {
        // Luipaard-achtige stipjes
        ctx.fillStyle = coatShade;
        for (const [ox, oy] of [[-4, -3], [-3, 3], [1, -4], [2, 2], [6, -2]]) {
          ctx.beginPath();
          ctx.arc(ox, oy, 1.3, 0, Math.PI * 2);
          ctx.fill();
        }
      }

      // 5. Halsband met Goud Belletje
      ctx.strokeStyle = collarColor;
      ctx.lineWidth = 2.2;
      ctx.beginPath();
      ctx.arc(8, 0, 5.2, -Math.PI * 0.45, Math.PI * 0.45);
      ctx.stroke();

      // Goud belletje
      ctx.fillStyle = '#fbbf24';
      ctx.beginPath();
      ctx.arc(9.2, 0, 1.8, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = '#d97706';
      ctx.beginPath();
      ctx.arc(9.2, 0, 0.6, 0, Math.PI * 2);
      ctx.fill();

      // 6. 3D Kopje met diepteverloop (Head with bobbing)
      const headBob = isMoving ? Math.sin(walk * 2) * 0.6 : 0;
      const headX = 11.5 + headBob;

      const headGrad = ctx.createRadialGradient(headX - 1, -1.5, 1, headX, 0, 6.5);
      headGrad.addColorStop(0, coatHighlight);
      headGrad.addColorStop(0.6, (cat.breed === 'siamese' ? coatShade : coatMain));
      headGrad.addColorStop(1, coatShade);

      ctx.fillStyle = headGrad;
      ctx.beginPath();
      ctx.arc(headX, 0, 6.2, 0, Math.PI * 2);
      ctx.fill();

      // 7. 3D Spitse Oortjes (Triangular ears with pink inner ear)
      // Linkeroor
      ctx.fillStyle = (cat.breed === 'siamese') ? coatShade : coatMain;
      ctx.beginPath();
      ctx.moveTo(headX - 1, -4);
      ctx.lineTo(headX + 4.5, -8.5);
      ctx.lineTo(headX + 4.5, -2.5);
      ctx.closePath();
      ctx.fill();
      // Roze binnenkant oor
      ctx.fillStyle = '#f472b6';
      ctx.beginPath();
      ctx.moveTo(headX, -4);
      ctx.lineTo(headX + 3.8, -7.2);
      ctx.lineTo(headX + 3.8, -3);
      ctx.closePath();
      ctx.fill();

      // Rechteroor
      ctx.fillStyle = (cat.breed === 'siamese') ? coatShade : coatMain;
      ctx.beginPath();
      ctx.moveTo(headX - 1, 4);
      ctx.lineTo(headX + 4.5, 8.5);
      ctx.lineTo(headX + 4.5, 2.5);
      ctx.closePath();
      ctx.fill();
      // Roze binnenkant oor
      ctx.fillStyle = '#f472b6';
      ctx.beginPath();
      ctx.moveTo(headX, 4);
      ctx.lineTo(headX + 3.8, 7.2);
      ctx.lineTo(headX + 3.8, 3);
      ctx.closePath();
      ctx.fill();

      // 8. Oogjes met glinstering & Schnauzer/Snorharen
      // Oogjes
      ctx.fillStyle = eyeColor;
      ctx.beginPath();
      ctx.arc(headX + 2.8, -2.4, 1.4, 0, Math.PI * 2);
      ctx.arc(headX + 2.8, 2.4, 1.4, 0, Math.PI * 2);
      ctx.fill();
      // Pupil (spleetoogje)
      ctx.fillStyle = '#020617';
      ctx.beginPath();
      ctx.ellipse(headX + 2.9, -2.4, 0.5, 1.1, 0, 0, Math.PI * 2);
      ctx.ellipse(headX + 2.9, 2.4, 0.5, 1.1, 0, 0, Math.PI * 2);
      ctx.fill();
      // Lichtreflectie
      ctx.fillStyle = '#ffffff';
      ctx.beginPath();
      ctx.arc(headX + 3.2, -2.6, 0.4, 0, Math.PI * 2);
      ctx.arc(headX + 3.2, 2.2, 0.4, 0, Math.PI * 2);
      ctx.fill();

      // Roze neusje
      ctx.fillStyle = '#f43f5e';
      ctx.beginPath();
      ctx.moveTo(headX + 5.6, 0);
      ctx.lineTo(headX + 4.8, -0.9);
      ctx.lineTo(headX + 4.8, 0.9);
      ctx.closePath();
      ctx.fill();

      // Fijne snorharen (Whiskers)
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.75)';
      ctx.lineWidth = 0.75;
      ctx.beginPath();
      ctx.moveTo(headX + 4.5, -1); ctx.lineTo(headX + 11, -5.5);
      ctx.moveTo(headX + 4.5, -0.5); ctx.lineTo(headX + 11.5, -2);
      ctx.moveTo(headX + 4.5, 1); ctx.lineTo(headX + 11, 5.5);
      ctx.moveTo(headX + 4.5, 0.5); ctx.lineTo(headX + 11.5, 2);
      ctx.stroke();

      // 9. Status & Naamlabel (Rechtop geroteerd voor uitstekende leesbaarheid)
      ctx.rotate(-cat.angle);
      ctx.fillStyle = '#ffffff';
      ctx.strokeStyle = 'rgba(0,0,0,0.85)';
      ctx.lineWidth = 2.5;
      ctx.font = 'bold 9.5px "Plus Jakarta Sans", sans-serif';
      ctx.textAlign = 'center';

      let stateIcon = '🐱';
      let stateSuffix = '';
      if (cat.state === 'fleeing') {
        stateIcon = '🙀';
        stateSuffix = ' 💨';
      } else if (cat.state === 'waiting_curb') {
        stateIcon = '👀';
        stateSuffix = ' 🛑 (Wacht op auto)';
      } else if (cat.state === 'crossing') {
        stateIcon = '🐾';
        stateSuffix = t('cat.crossing');
      } else if (cat.state === 'sniffing') {
        stateIcon = '🐾';
        stateSuffix = ' 🌸';
      } else if (cat.state === 'sitting') {
        stateIcon = '😺';
        stateSuffix = ' 💤';
      } else if (cat.state === 'stretching') {
        stateIcon = '🐱';
        stateSuffix = ' ✨';
      }

      // Rustig scherm: namen en praatwolkjes van katten alleen vlakbij de scooter
      if (this.near(cat.x, cat.y, 190)) {
        const catLabel = `${stateIcon} ${cat.name}${stateSuffix}`;
        ctx.strokeText(catLabel, 0, -20);
        ctx.fillText(catLabel, 0, -20);
      }

      // 10. Schattige tekst-/gedachteballon als de kat wacht of reageert
      if (cat.speechText && cat.speechTimer > 0 && this.near(cat.x, cat.y, 230)) {
        ctx.font = 'bold 9px "Plus Jakarta Sans", sans-serif';
        const txtWidth = ctx.measureText(cat.speechText).width;
        const bW = txtWidth + 14;
        const bH = 18;
        const bX = -bW / 2;
        const bY = -42;

        ctx.fillStyle = '#fffbeb'; // Warme amber/room tint
        ctx.strokeStyle = '#d97706';
        ctx.lineWidth = 1.4;
        ctx.beginPath();
        ctx.roundRect(bX, bY, bW, bH, 6);
        ctx.fill();
        ctx.stroke();

        // Pijltje naar het kattenkopje
        ctx.beginPath();
        ctx.moveTo(-3, bY + bH);
        ctx.lineTo(0, bY + bH + 4);
        ctx.lineTo(3, bY + bH);
        ctx.fillStyle = '#fffbeb';
        ctx.fill();
        ctx.strokeStyle = '#d97706';
        ctx.stroke();

        ctx.fillStyle = '#78350f';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(cat.speechText, 0, bY + bH / 2);
      }

      ctx.restore();
    }
  }

  renderShockParticles(ctx) {
    if (!this.shockParticles.length) return;
    ctx.save();
    for (const sp of this.shockParticles) {
      ctx.fillStyle = `rgba(239, 68, 68, ${sp.alpha})`;
      ctx.strokeStyle = `rgba(0, 0, 0, ${sp.alpha * 0.8})`;
      ctx.lineWidth = 3;
      ctx.font = 'bold 15px "Plus Jakarta Sans", sans-serif';
      ctx.textAlign = 'center';
      ctx.strokeText(sp.text, sp.x, sp.y);
      ctx.fillText(sp.text, sp.x, sp.y);
    }
    ctx.restore();
  }

  renderConfetti(ctx) {
    if (!this.confettiParticles.length) return;
    ctx.save();
    for (const cp of this.confettiParticles) {
      ctx.fillStyle = cp.color;
      ctx.globalAlpha = Math.max(0, cp.alpha);
      ctx.fillRect(cp.x, cp.y, cp.size, cp.size * 0.8);
    }
    ctx.restore();
  }

  renderExhaust(ctx) {
    ctx.save();
    for (const p of this.scooter.exhaustParticles) {
      if (p.color) {
        ctx.fillStyle = p.color;
        ctx.globalAlpha = p.alpha;
      } else if (p.isSpark) {
        ctx.fillStyle = `rgba(245, 158, 11, ${p.alpha})`;
        ctx.globalAlpha = 1.0;
      } else {
        ctx.fillStyle = `rgba(200, 200, 210, ${p.alpha})`;
        ctx.globalAlpha = 1.0;
      }
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.restore();
  }

  renderScooter(ctx) {
    const s = this.scooter;
    if (s.vehicleType === 'van') {
      this.renderPlayerVan(ctx);
      return;
    }

    const jumpElevation = s.jumpZ || 0;
    const scaleFactor = 1.0 + Math.min(0.35, jumpElevation * 0.035);

    ctx.save();
    ctx.translate(s.x, s.y + s.bumpOffset);
    ctx.rotate(s.angle);

    // 1. Scooter Shadow on ground level (stays at ground distance during jump)
    ctx.fillStyle = jumpElevation > 0 ? 'rgba(0, 0, 0, 0.16)' : 'rgba(0, 0, 0, 0.28)';
    ctx.beginPath();
    ctx.ellipse(3 + jumpElevation * 0.4, 3 + jumpElevation * 0.4, 28, 14, 0, 0, Math.PI * 2);
    ctx.fill();

    // Scale up slightly for 3D aerial elevation effect
    if (jumpElevation > 0) {
      ctx.scale(scaleFactor, scaleFactor);
    }

    // 2. Headlight Beam (in front of the scooter)
    this.renderHeadlightCone(ctx);

    // 3. Top-Down Crafted Delivery Scooter Model
    // Rear wheel (drawn under frame)
    ctx.fillStyle = '#09090b';
    ctx.fillRect(-22, -3.5, 12, 7);
    if (s.hasSportVelgen) {
      ctx.fillStyle = '#facc15';
      ctx.fillRect(-19, -3.5, 6, 7);
      ctx.fillStyle = '#b45309';
      ctx.fillRect(-17, -3.5, 2, 7);
    }

    // Frame & body chassis (custom paint color!)
    ctx.fillStyle = s.paintColor || '#dc2626';
    ctx.beginPath();
    ctx.roundRect(-22, -10, 44, 20, [8, 14, 14, 8]);
    ctx.fill();

    // Front Mudguard & Wheel
    ctx.save();
    ctx.translate(24, 0);
    ctx.rotate(s.steerAngle); // Wheel turns with steering!

    // Front tire
    ctx.fillStyle = '#09090b';
    ctx.fillRect(-6, -3.5, 14, 7);
    if (s.hasSportVelgen) {
      // Gold sport rim line
      ctx.fillStyle = '#facc15';
      ctx.fillRect(-3, -3.5, 6, 7);
      ctx.fillStyle = '#b45309';
      ctx.fillRect(-1, -3.5, 2, 7);
    }

    // Handlebars with grips & side mirrors
    ctx.fillStyle = '#27272a';
    ctx.fillRect(-3, -16, 6, 32);
    // Chrome brake levers & grips
    ctx.fillStyle = '#e4e4e7';
    ctx.fillRect(-2, -18, 4, 4);
    ctx.fillRect(-2, 14, 4, 4);
    // Headlight glass on front
    ctx.fillStyle = '#fef08a';
    ctx.beginPath();
    ctx.arc(7, 0, 4, -Math.PI / 2, Math.PI / 2);
    ctx.fill();
    ctx.restore();

    // Footrest floorboard (dark rubber with grip ribs)
    ctx.fillStyle = '#18181b';
    ctx.fillRect(-4, -8, 16, 16);

    // Tuned Sport Exhaust (if turbo upgrade is equipped)
    if (s.hasTurbo) {
      // Chrome tuned exhaust pipe on side
      ctx.fillStyle = '#94a3b8';
      ctx.fillRect(-24, 7.5, 18, 4);
      // Heat-treated titanium blue tip
      ctx.fillStyle = '#38bdf8';
      ctx.fillRect(-28, 7, 5, 5);
      ctx.fillStyle = '#1e1b4b';
      ctx.fillRect(-29, 8, 2, 3);

      // Flash flame spark if accelerating at high speed
      if (Math.abs(s.speed) > 1.8 && (s.keys.up || s.analogThrottle > 0.3) && Math.random() < 0.45) {
        ctx.fillStyle = Math.random() < 0.5 ? '#f97316' : '#38bdf8';
        ctx.beginPath();
        ctx.arc(-32 - Math.random() * 4, 9.5 + (Math.random() - 0.5) * 3, 2 + Math.random() * 2, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    // Bezorger Driver (Helmet & Jacket)
    // Driver Body (delivery jacket)
    ctx.fillStyle = '#d97706'; // Amber Knus & Krokant delivery uniform
    ctx.beginPath();
    ctx.ellipse(-2, 0, 10, 9, 0, 0, Math.PI * 2);
    ctx.fill();

    // Driver Helmet with visor
    ctx.fillStyle = '#ffffff'; // White safety helmet
    ctx.beginPath();
    ctx.arc(-2, 0, 7.5, 0, Math.PI * 2);
    ctx.fill();
    // Visor facing front
    ctx.fillStyle = '#1e293b';
    ctx.beginPath();
    ctx.arc(1, 0, 6, -Math.PI / 3, Math.PI / 3);
    ctx.fill();

    // Rear cargo box based on configuration
    if (s.boxType === 'kleinebak') {
      // Compact delivery box
      ctx.fillStyle = '#ffffff';
      ctx.strokeStyle = '#f59e0b';
      ctx.lineWidth = 2;
      ctx.fillRect(-26, -11, 14, 22);
      ctx.strokeRect(-26, -11, 14, 22);
      // Small logo dot
      ctx.fillStyle = '#b45309';
      ctx.beginPath();
      ctx.arc(-19, 0, 3.5, 0, Math.PI * 2);
      ctx.fill();
    } else if (s.boxType === 'grotebak') {
      // Large catering thermal box
      ctx.fillStyle = '#fffbeb';
      ctx.strokeStyle = '#d97706';
      ctx.lineWidth = 2.5;
      ctx.fillRect(-32, -13, 20, 26);
      ctx.strokeRect(-32, -13, 20, 26);
      // Knus & Krokant text / icon on box lid
      ctx.fillStyle = '#92400e';
      ctx.font = 'bold 8px "Plus Jakarta Sans", sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText('K&K', -22, 3);
    }

    // Rear Taillight (bright red when braking or reversing)
    const isBraking = s.keys.down || s.keys.handbrake;
    ctx.fillStyle = isBraking ? '#ef4444' : '#991b1b';
    ctx.shadowColor = isBraking ? '#ef4444' : 'transparent';
    ctx.shadowBlur = isBraking ? 12 : 0;
    ctx.fillRect(s.boxType === 'grotebak' ? -34 : (s.boxType === 'kleinebak' ? -28 : -23), -3, 3, 6);
    ctx.shadowBlur = 0;

    ctx.restore();
  }

  // Dedicated rendering for Player Delivery Van ("De Bakkerij Express")
  renderPlayerVan(ctx) {
    const s = this.scooter;
    const jumpElevation = s.jumpZ || 0;
    const scaleFactor = 1.0 + Math.min(0.35, jumpElevation * 0.035);

    ctx.save();
    ctx.translate(s.x, s.y + s.bumpOffset);
    ctx.rotate(s.angle);

    const length = 76;
    const width = 36;
    const halfL = length / 2;
    const halfW = width / 2;

    // 1. Van Ground Shadow
    ctx.fillStyle = jumpElevation > 0 ? 'rgba(0, 0, 0, 0.18)' : 'rgba(0, 0, 0, 0.32)';
    ctx.beginPath();
    ctx.ellipse(4 + jumpElevation * 0.4, 4 + jumpElevation * 0.4, halfL + 4, halfW + 3, 0, 0, Math.PI * 2);
    ctx.fill();

    // Scale up slightly for 3D aerial elevation effect
    if (jumpElevation > 0) {
      ctx.scale(scaleFactor, scaleFactor);
    }

    // 2. Dual Front Headlights Beam
    this.renderHeadlightCone(ctx);

    // 3. Wheels with Sport Rims
    const wheelL = 16;
    const wheelW = 6;

    // Front Wheels (Steerable with s.steerAngle)
    [-halfW - 2, halfW - wheelW + 2].forEach(yPos => {
      ctx.save();
      ctx.translate(halfL - 18, yPos + wheelW / 2);
      ctx.rotate(s.steerAngle * 0.8);
      ctx.fillStyle = '#09090b';
      ctx.fillRect(-wheelL / 2, -wheelW / 2, wheelL, wheelW);
      ctx.fillStyle = s.hasSportVelgen ? '#f59e0b' : '#a8a29e';
      ctx.fillRect(-wheelL / 4, -wheelW / 2 + 1, wheelL / 2, wheelW - 2);
      ctx.restore();
    });

    // Rear Wheels
    [-halfW - 2, halfW - wheelW + 2].forEach(yPos => {
      ctx.fillStyle = '#09090b';
      ctx.fillRect(-halfL + 12, yPos, wheelL, wheelW);
      ctx.fillStyle = s.hasSportVelgen ? '#f59e0b' : '#a8a29e';
      ctx.fillRect(-halfL + 12 + wheelL / 4, yPos + 1, wheelL / 2, wheelW - 2);
    });

    // 4. Main Body Chassis (Warm bakery ivory/cream or custom paint)
    ctx.fillStyle = s.paintColor || '#fffbeb';
    ctx.beginPath();
    ctx.roundRect(-halfL, -halfW, length, width, [10, 14, 14, 10]);
    ctx.fill();
    ctx.strokeStyle = '#d97706';
    ctx.lineWidth = 2;
    ctx.stroke();

    // 5. Front Hood & Grille
    ctx.fillStyle = '#b45309';
    ctx.fillRect(halfL - 6, -halfW + 6, 5, width - 12);
    // Headlight lenses
    ctx.fillStyle = '#fef08a';
    ctx.fillRect(halfL - 4, -halfW + 3, 3, 5);
    ctx.fillRect(halfL - 4, halfW - 8, 3, 5);

    // 6. Cabin Windshield & Windows
    ctx.fillStyle = '#1e293b';
    ctx.beginPath();
    ctx.roundRect(halfL - 26, -halfW + 4, 12, width - 8, 3);
    ctx.fill();
    // Glass reflection glare
    ctx.fillStyle = 'rgba(255, 255, 255, 0.45)';
    ctx.beginPath();
    ctx.moveTo(halfL - 24, -halfW + 6);
    ctx.lineTo(halfL - 16, -halfW + 6);
    ctx.lineTo(halfL - 22, halfW - 6);
    ctx.closePath();
    ctx.fill();

    // Side windows
    ctx.fillStyle = '#1e293b';
    ctx.fillRect(halfL - 38, -halfW + 2, 10, 3);
    ctx.fillRect(halfL - 38, halfW - 5, 10, 3);

    // 7. Driver with white baker cap
    ctx.fillStyle = '#fde047';
    ctx.beginPath();
    ctx.arc(halfL - 20, 0, 4.5, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(halfL - 21, 0, 5.5, 0, Math.PI * 2);
    ctx.fill();

    // 8. Bakery Cargo Bay Roof & Golden Croissant Emblem
    ctx.fillStyle = '#fef3c7';
    ctx.beginPath();
    ctx.roundRect(-halfL + 6, -halfW + 4, 38, width - 8, 4);
    ctx.fill();
    ctx.strokeStyle = '#f59e0b';
    ctx.lineWidth = 1;
    ctx.stroke();

    ctx.fillStyle = '#92400e';
    ctx.font = 'bold 7px "Plus Jakarta Sans", sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText(t('world.bakery'), -halfL + 25, -2);
    ctx.font = 'bold 6px "Plus Jakarta Sans", sans-serif';
    ctx.fillText('EXPRESS', -halfL + 25, 6);

    // Side Mirrors
    ctx.fillStyle = '#27272a';
    ctx.fillRect(halfL - 20, -halfW - 3, 3, 4);
    ctx.fillRect(halfL - 20, halfW - 1, 3, 4);

    // 9. Rear Taillights & Dynamic Brake Lights
    const isBraking = s.keys.down || s.keys.handbrake || (s.analogThrottle < -0.16);
    ctx.fillStyle = isBraking ? '#ef4444' : '#991b1b';
    ctx.shadowColor = isBraking ? '#ef4444' : 'transparent';
    ctx.shadowBlur = isBraking ? 14 : 0;
    ctx.fillRect(-halfL - 1, -halfW + 3, 3, 6);
    ctx.fillRect(-halfL - 1, halfW - 9, 3, 6);
    ctx.shadowBlur = 0;

    // 10. Turn signal blinker
    const blinkOn = Math.floor(performance.now() / 200) % 2 === 0;
    if (blinkOn) {
      if (s.steerAngle < -0.1) {
        ctx.fillStyle = '#f59e0b';
        ctx.fillRect(halfL - 3, -halfW + 1, 3, 3);
        ctx.fillRect(-halfL, -halfW + 1, 2, 3);
      } else if (s.steerAngle > 0.1) {
        ctx.fillStyle = '#f59e0b';
        ctx.fillRect(halfL - 3, halfW - 4, 3, 3);
        ctx.fillRect(-halfL, halfW - 4, 2, 3);
      }
    }

    ctx.restore();
  }

  renderHeadlightCone(ctx) {
    // Project glowing light cone ahead
    const coneLength = this.isNight ? 180 : 100;
    const coneWidth = this.isNight ? 75 : 45;

    ctx.save();
    const grad = ctx.createRadialGradient(24, 0, 4, coneLength, 0, coneWidth * 1.4);
    if (this.isNight) {
      grad.addColorStop(0, 'rgba(254, 240, 138, 0.75)');
      grad.addColorStop(0.35, 'rgba(254, 240, 138, 0.4)');
      grad.addColorStop(1, 'rgba(254, 240, 138, 0)');
    } else {
      grad.addColorStop(0, 'rgba(254, 240, 138, 0.35)');
      grad.addColorStop(1, 'rgba(254, 240, 138, 0)');
    }

    ctx.fillStyle = grad;
    ctx.beginPath();
    ctx.moveTo(24, 0);
    ctx.lineTo(24 + coneLength, -coneWidth);
    ctx.lineTo(24 + coneLength, coneWidth);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
  }

  // 4b. Render Collectible Coins
  renderCoins(ctx) {
    if (!this.map.collectibleCoins) return;
    for (const coin of this.map.collectibleCoins) {
      if (!this.inView(coin.x, coin.y, 60)) continue; // buiten beeld: overslaan
      if (coin.collected) continue;

      ctx.save();
      ctx.translate(coin.x, coin.y);

      // 3D Spinning width factor
      const spin = Math.cos(coin.animTimer || 0);
      const absSpin = Math.max(0.18, Math.abs(spin));
      const isBig = coin.value > 1;
      const baseR = isBig ? 13 : 9.5;

      // Drop shadow on asphalt
      ctx.fillStyle = 'rgba(0, 0, 0, 0.22)';
      ctx.beginPath();
      ctx.ellipse(0, baseR * 0.7, baseR * absSpin, baseR * 0.4, 0, 0, Math.PI * 2);
      ctx.fill();

      // Golden Aura Glow
      const glowGrad = ctx.createRadialGradient(0, 0, 2, 0, 0, baseR * 1.8);
      glowGrad.addColorStop(0, isBig ? 'rgba(245, 158, 11, 0.35)' : 'rgba(251, 191, 36, 0.25)');
      glowGrad.addColorStop(1, 'rgba(245, 158, 11, 0)');
      ctx.fillStyle = glowGrad;
      ctx.beginPath();
      ctx.arc(0, 0, baseR * 1.8, 0, Math.PI * 2);
      ctx.fill();

      // Coin Body (Spinned)
      ctx.save();
      ctx.scale(absSpin, 1);

      // Outer rim
      ctx.fillStyle = isBig ? '#d97706' : '#b45309';
      ctx.beginPath();
      ctx.arc(0, 0, baseR, 0, Math.PI * 2);
      ctx.fill();

      // Inner coin face with sheen gradient
      const faceGrad = ctx.createLinearGradient(-baseR, -baseR, baseR, baseR);
      if (spin >= 0) {
        faceGrad.addColorStop(0, '#fde047');
        faceGrad.addColorStop(0.5, '#f59e0b');
        faceGrad.addColorStop(1, '#b45309');
      } else {
        faceGrad.addColorStop(0, '#fef08a');
        faceGrad.addColorStop(0.5, '#fbbf24');
        faceGrad.addColorStop(1, '#d97706');
      }
      ctx.fillStyle = faceGrad;
      ctx.beginPath();
      ctx.arc(0, 0, baseR - 1.8, 0, Math.PI * 2);
      ctx.fill();

      // Embossed relief ring
      ctx.strokeStyle = isBig ? '#78350f' : '#92400e';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.arc(0, 0, baseR - 3.5, 0, Math.PI * 2);
      ctx.stroke();

      // Center symbol: "★" for big coin, "€" for standard coin
      ctx.fillStyle = '#78350f';
      ctx.font = isBig ? 'bold 9px sans-serif' : 'bold 7px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(isBig ? '★' : '€', 0, 0.5);

      ctx.restore();

      // Gleam diamond sparkle
      const gleamAlpha = Math.max(0, Math.sin(coin.animTimer * 2));
      if (gleamAlpha > 0.3) {
        ctx.save();
        ctx.globalAlpha = gleamAlpha;
        ctx.fillStyle = '#ffffff';
        const gx = (baseR * 0.7) * spin;
        const gy = -baseR * 0.6;
        ctx.beginPath();
        ctx.moveTo(gx, gy - 3);
        ctx.lineTo(gx + 2, gy);
        ctx.lineTo(gx, gy + 3);
        ctx.lineTo(gx - 2, gy);
        ctx.closePath();
        ctx.fill();
        ctx.restore();
      }

      ctx.restore();
    }
  }

  // 5b. Render Traffic Cars & File-auto's
  renderCars(ctx) {
    const allCars = [...(this.map.cars || [])];
    if (this.map.trafficJams) {
      for (const jam of this.map.trafficJams) {
        if (jam.active && jam.cars) {
          allCars.push(...jam.cars);
        }
      }
    }
    if (allCars.length === 0) return;

    for (const car of allCars) {
      if (!this.inView(car.x, car.y, 160)) continue; // buiten beeld: overslaan
      ctx.save();
      ctx.translate(car.x, car.y);
      ctx.rotate(car.angle);
      if (car.vibration) {
        ctx.translate(0, car.vibration);
      }

      const L = car.length / 2;
      const W = car.width / 2;

      // 1. Drop shadow
      ctx.fillStyle = 'rgba(0, 0, 0, 0.28)';
      ctx.beginPath();
      ctx.roundRect(-L + 3, -W + 4, car.length, car.width, 8);
      ctx.fill();

      // 2. Rubber Wheels peeking at corners
      ctx.fillStyle = '#0f172a';
      // Front tires
      ctx.fillRect(L * 0.45, -W - 3, 14, 5);
      ctx.fillRect(L * 0.45, W - 2, 14, 5);
      // Rear tires
      ctx.fillRect(-L * 0.75, -W - 3, 14, 5);
      ctx.fillRect(-L * 0.75, W - 2, 14, 5);

      // 3. Car Body Chassis
      ctx.fillStyle = car.color;
      ctx.beginPath();
      ctx.roundRect(-L, -W, car.length, car.width, 7);
      ctx.fill();

      // Politie striping (Nederlandse Bizz-striping in rood/blauw)
      if (car.isPolice || car.model === 'police') {
        ctx.save();
        // Schuin aflopende strepen op motorkap & zijkanten
        const stripeColors = ['#0047bb', '#ffffff', '#ea2027', '#0047bb'];
        // Motorkap striping
        for (let i = 0; i < stripeColors.length; i++) {
          ctx.fillStyle = stripeColors[i];
          ctx.beginPath();
          ctx.moveTo(L * 0.55 + (i * 3.5), -W + 3);
          ctx.lineTo(L * 0.7 + (i * 3.5), -W + 3);
          ctx.lineTo(L * 0.45 + (i * 3.5), W - 3);
          ctx.lineTo(L * 0.3 + (i * 3.5), W - 3);
          ctx.closePath();
          ctx.fill();
        }

        // Politie tekst op de motorkap
        ctx.fillStyle = '#0047bb';
        ctx.font = '900 8.5px "Plus Jakarta Sans", sans-serif';
        ctx.textAlign = 'center';
        ctx.fillText(t('world.policeCaps'), L * 0.72, 3);
        ctx.restore();
      }

      // Subtle contour edge
      ctx.strokeStyle = car.roofColor || 'rgba(0,0,0,0.3)';
      ctx.lineWidth = 1.5;
      ctx.stroke();

      // 4. Cabin & Windows
      if (car.model === 'cabrio') {
        // Cabrio: open cockpit with leather seats & steering wheel
        ctx.fillStyle = '#334155';
        ctx.beginPath();
        ctx.roundRect(-L + 12, -W + 4, car.length - 24, car.width - 8, 4);
        ctx.fill();

        // Leather seats (two front seats)
        ctx.fillStyle = '#78350f';
        ctx.beginPath();
        ctx.roundRect(-4, -W + 6, 12, (car.width - 14) / 2, 3);
        ctx.roundRect(-4, 1, 12, (car.width - 14) / 2, 3);
        ctx.fill();

        // Steering wheel
        ctx.strokeStyle = '#e2e8f0';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(10, -4, 4, 0, Math.PI * 2);
        ctx.stroke();

        // Small windshield in front
        ctx.fillStyle = 'rgba(56, 189, 248, 0.6)';
        ctx.fillRect(16, -W + 5, 4, car.width - 10);
      } else {
        // Standard closed cabin
        const cabinX = -L + (car.model === 'station' || car.model === 'van' ? 10 : 14);
        const cabinW = car.length - (car.model === 'van' ? 16 : 24);
        const cabinH = car.width - 8;

        // Dark window frame base
        ctx.fillStyle = '#0f172a';
        ctx.beginPath();
        ctx.roundRect(cabinX, -cabinH / 2, cabinW, cabinH, 4);
        ctx.fill();

        // Front Windscreen with sheen
        ctx.fillStyle = '#38bdf8';
        ctx.globalAlpha = 0.55;
        ctx.beginPath();
        ctx.roundRect(cabinX + cabinW - 10, -cabinH / 2 + 2, 8, cabinH - 4, 2);
        ctx.fill();

        // Rear Window
        ctx.beginPath();
        ctx.roundRect(cabinX + 2, -cabinH / 2 + 2, 6, cabinH - 4, 2);
        ctx.fill();
        ctx.globalAlpha = 1.0;

        // Roof Panel
        ctx.fillStyle = car.roofColor || car.color;
        ctx.beginPath();
        ctx.roundRect(cabinX + 7, -cabinH / 2 + 3, cabinW - 16, cabinH - 6, 3);
        ctx.fill();

        // Model specific details
        if (car.model === 'suv') {
          // Roof rack rails
          ctx.strokeStyle = '#94a3b8';
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.moveTo(cabinX + 10, -cabinH / 2 + 4);
          ctx.lineTo(cabinX + cabinW - 12, -cabinH / 2 + 4);
          ctx.moveTo(cabinX + 10, cabinH / 2 - 4);
          ctx.lineTo(cabinX + cabinW - 12, cabinH / 2 - 4);
          ctx.stroke();
        } else if (car.model === 'van') {
          // Cargo roof lines
          ctx.strokeStyle = 'rgba(255, 255, 255, 0.2)';
          ctx.lineWidth = 1;
          for (let rx = cabinX + 10; rx < cabinX + cabinW - 10; rx += 8) {
            ctx.beginPath();
            ctx.moveTo(rx, -cabinH / 2 + 4);
            ctx.lineTo(rx, cabinH / 2 - 4);
            ctx.stroke();
          }
        } else if (car.isPolice || car.model === 'police') {
          // Politie daktekst
          ctx.fillStyle = '#0047bb';
          ctx.font = 'bold 7px "Plus Jakarta Sans", sans-serif';
          ctx.textAlign = 'center';
          ctx.fillText(t('world.policeCaps'), cabinX + cabinW / 2, 2.5);

          // 3D Aerodynamische Politie Zwaailichtbalk (Emergency Lightbar)
          const barX = cabinX + cabinW * 0.48;
          const barW = 7;
          const barH = cabinH - 2;

          // Montagevoetjes
          ctx.fillStyle = '#1e293b';
          ctx.fillRect(barX - 1, -barH / 2, barW + 2, barH);

          // Zwaailampen links (blauw) en rechts (rood/blauw)
          const nowMs = Date.now();
          const flashPhase = Math.floor((nowMs / 130) % 4);
          const isBlueLit = (flashPhase === 0 || flashPhase === 1);
          const isRedLit = (flashPhase === 2 || flashPhase === 3);

          if (car.sirenActive) {
            // Actieve zwaailichten met felle flits en glow
            ctx.save();
            ctx.shadowBlur = 18;

            // Blauwe flitser
            ctx.shadowColor = '#3b82f6';
            ctx.fillStyle = isBlueLit ? '#60a5fa' : '#1e3a8a';
            ctx.beginPath();
            ctx.roundRect(barX, -barH / 2 + 1, barW, barH / 2 - 2, 2);
            ctx.fill();

            // Rode/witte flitser
            ctx.shadowColor = '#ef4444';
            ctx.fillStyle = isRedLit ? '#f87171' : '#7f1d1d';
            ctx.beginPath();
            ctx.roundRect(barX, 1, barW, barH / 2 - 2, 2);
            ctx.fill();

            ctx.restore();

            // Zwaailicht lichtflits op het wegdek rondom de politiewagen
            ctx.save();
            const haloGrad = ctx.createRadialGradient(0, 0, 10, 0, 0, 85);
            if (isBlueLit) {
              haloGrad.addColorStop(0, 'rgba(59, 130, 246, 0.48)');
              haloGrad.addColorStop(0.7, 'rgba(37, 99, 235, 0.16)');
              haloGrad.addColorStop(1, 'rgba(37, 99, 235, 0)');
            } else {
              haloGrad.addColorStop(0, 'rgba(239, 68, 68, 0.48)');
              haloGrad.addColorStop(0.7, 'rgba(220, 38, 38, 0.16)');
              haloGrad.addColorStop(1, 'rgba(220, 38, 38, 0)');
            }
            ctx.fillStyle = haloGrad;
            ctx.beginPath();
            ctx.arc(0, 0, 85, 0, Math.PI * 2);
            ctx.fill();
            ctx.restore();
          } else {
            // Rustige patrouille / standbystand
            ctx.fillStyle = '#2563eb';
            ctx.fillRect(barX, -barH / 2 + 1, barW, barH / 2 - 2);
            ctx.fillStyle = '#dc2626';
            ctx.fillRect(barX, 1, barW, barH / 2 - 2);
          }
        }
      }

      // 5. Side Mirrors
      ctx.fillStyle = car.color;
      ctx.fillRect(L * 0.3, -W - 3, 5, 3);
      ctx.fillRect(L * 0.3, W, 5, 3);

      // 6. Headlights & Beams
      const isLightsOn = this.isNight || car.flashTimer > 0;
      ctx.fillStyle = (car.flashTimer > 0) ? '#ffffff' : '#fef08a';
      ctx.beginPath();
      ctx.arc(L - 2, -W + 5, 3, 0, Math.PI * 2);
      ctx.arc(L - 2, W - 5, 3, 0, Math.PI * 2);
      ctx.fill();

      // Headlight light beams casting on the road
      if (isLightsOn) {
        ctx.save();
        const beamGrad = ctx.createLinearGradient(L, 0, L + 140, 0);
        beamGrad.addColorStop(0, car.flashTimer > 0 ? 'rgba(255, 255, 255, 0.65)' : 'rgba(254, 240, 138, 0.45)');
        beamGrad.addColorStop(1, 'rgba(254, 240, 138, 0)');
        ctx.fillStyle = beamGrad;
        ctx.beginPath();
        ctx.moveTo(L, -W + 5);
        ctx.lineTo(L + 140, -W - 35);
        ctx.lineTo(L + 140, W + 35);
        ctx.lineTo(L, W - 5);
        ctx.closePath();
        ctx.fill();
        ctx.restore();
      }

      // 7. Taillights (Intense glowing red when braking!)
      if (car.isBraking) {
        ctx.shadowColor = '#ef4444';
        ctx.shadowBlur = 12;
        ctx.fillStyle = '#ff2222';
      } else {
        ctx.shadowBlur = 0;
        ctx.fillStyle = this.isNight ? '#ef4444' : '#991b1b';
      }
      ctx.fillRect(-L, -W + 4, 3, 7);
      ctx.fillRect(-L, W - 11, 3, 7);
      ctx.shadowBlur = 0;

      // Politie achterbumper chevrons & tekst
      if (car.isPolice || car.model === 'police') {
        ctx.fillStyle = '#ea2027';
        ctx.fillRect(-L - 1, -W + 2, 2.5, W * 2 - 4);
        ctx.fillStyle = '#fef08a';
        ctx.fillRect(-L - 1, -W / 2, 2.5, W);

        // Politie overhead naam- & statuslabel
        ctx.save();
        ctx.rotate(-car.angle);
        ctx.font = 'bold 9.5px "Plus Jakarta Sans", sans-serif';
        ctx.textAlign = 'center';
        ctx.fillStyle = '#ffffff';
        ctx.strokeStyle = 'rgba(0, 0, 0, 0.85)';
        ctx.lineWidth = 2.5;

        if (car.state === 'chase' || this.near(car.x, car.y, 170)) {
          const policeTitle = car.state === 'chase' ? t('world.policeChase') : t('world.police');
          ctx.strokeText(policeTitle, 0, -W - 12);
          ctx.fillText(policeTitle, 0, -W - 12);
        }
        ctx.restore();
      }

      // 8. Stadstaxi Dakbord
      if (car.model === 'taxi') {
        ctx.fillStyle = '#f59e0b';
        ctx.beginPath();
        ctx.roundRect(-4, -6, 8, 12, 2);
        ctx.fill();
        ctx.strokeStyle = '#000000';
        ctx.lineWidth = 1;
        ctx.stroke();
        ctx.fillStyle = '#000000';
        ctx.font = 'bold 5px sans-serif';
        ctx.textAlign = 'center';
        ctx.fillText('TAXI', 0, 2);
      }

      // 9. Knipperlichten / Alarmlichten (Hazards)
      if (car.hazardBlink || car.hazardTimer > 0) {
        const blink = Math.floor(Date.now() / 220) % 2 === 0;
        if (blink) {
          ctx.save();
          ctx.fillStyle = '#f59e0b';
          ctx.shadowColor = '#f59e0b';
          ctx.shadowBlur = 8;
          // 4 hoeken amber knipperlichten
          ctx.fillRect(L - 4, -W, 5, 4);
          ctx.fillRect(L - 4, W - 4, 5, 4);
          ctx.fillRect(-L, -W, 5, 4);
          ctx.fillRect(-L, W - 4, 5, 4);
          ctx.restore();
        }
      }

      // 10. Strips & Speech bubble voor interactieve reacties (Toeteren / Aanrijding / Blokkade)
      if (car.speechText && car.speechTimer > 0 && (this.near(car.x, car.y, 260) || (car.isPolice && car.state === 'chase'))) {
        ctx.save();
        ctx.rotate(-car.angle); // Houd tekstballon altijd perfect rechtop
        ctx.font = 'bold 11px "Plus Jakarta Sans", sans-serif';
        const text = car.speechText;
        const textW = ctx.measureText(text).width;
        const boxW = Math.max(130, textW + 18);
        const boxH = 26;
        const bubbleX = -boxW / 2;
        const bubbleY = -W - 46;

        // Schaduw
        ctx.fillStyle = 'rgba(0, 0, 0, 0.35)';
        ctx.beginPath();
        ctx.roundRect(bubbleX + 2, bubbleY + 2, boxW, boxH, 8);
        ctx.fill();

        // Ballon
        ctx.fillStyle = '#ffffff';
        ctx.strokeStyle = '#334155';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.roundRect(bubbleX, bubbleY, boxW, boxH, 8);
        ctx.fill();
        ctx.stroke();

        // Pijltje naar het autodak
        ctx.beginPath();
        ctx.moveTo(-5, bubbleY + boxH);
        ctx.lineTo(0, bubbleY + boxH + 7);
        ctx.lineTo(5, bubbleY + boxH);
        ctx.fillStyle = '#ffffff';
        ctx.fill();
        ctx.strokeStyle = '#334155';
        ctx.stroke();

        // Tekst
        ctx.fillStyle = '#0f172a';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, 0, bubbleY + boxH / 2);
        ctx.restore();
      }

      ctx.restore();
    }
  }

  // 8b. Render Floating Text Indicators (+coins, damage, notifications)
  renderFloatingTexts(ctx) {
    if (!this.floatingTexts || this.floatingTexts.length === 0) return;
    for (const ft of this.floatingTexts) {
      ctx.save();
      ctx.globalAlpha = Math.max(0, Math.min(1, ft.alpha));
      ctx.font = 'bold 15px "Plus Jakarta Sans", sans-serif';
      ctx.textAlign = 'center';
      ctx.strokeStyle = 'rgba(0, 0, 0, 0.75)';
      ctx.lineWidth = 3.5;
      ctx.strokeText(ft.text, ft.x, ft.y);
      ctx.fillStyle = ft.color || '#f59e0b';
      ctx.fillText(ft.text, ft.x, ft.y);
      ctx.restore();
    }
  }

}
